import { render, staticRenderFns } from "./DetailPenerbitanSudahBayar.vue?vue&type=template&id=6afca21e&"
import script from "./DetailPenerbitanSudahBayar.vue?vue&type=script&lang=js&"
export * from "./DetailPenerbitanSudahBayar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports